import { render, staticRenderFns } from "./PaymentCompleted.vue?vue&type=template&id=f42c0e36&scoped=true&"
import script from "./PaymentCompleted.vue?vue&type=script&lang=js&"
export * from "./PaymentCompleted.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCompleted.vue?vue&type=style&index=0&id=f42c0e36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42c0e36",
  null
  
)

export default component.exports